import React from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import useAuth from "../hooks/useAuth";

function DeleteQuestionModal(props) {
  const { modal, setModal, id, fetchQuestions } = props;
  const { user } = useAuth();
  const handleDelete = async () => {
    try {
      await deleteQuestion(id); // 🔥 API call

      // close modal
      setModal({ show: false, id: null });

      // ✅ refresh questions after delete
      fetchQuestions();

    } catch (error) {
      console.error("Delete failed", error);
    }
  };
  async function deleteQuestion() {
    let URL = process.env.REACT_APP_API_URL + "/delete-question";
    let payload = { _id: props.id };
    axios
      .post(URL, payload, { headers: { Authorization: "Bearer " + user.jwtToken } })
      .then((response) => {
        props.setModal({
          show: false,
          id: null,
        });
      });
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={"modal fade " + (props.modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={props.modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                Delete User
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  props.setModal(false);
                }}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p className="fs-2 text-center">Are you sure?</p>
              <p className="fs-5 text-center">
                Do you really want to delete this question?
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => {
                  props.setModal(false);
                }}
              >
                No
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleDelete}
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      {props.modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default DeleteQuestionModal;
